import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_SHIPPING_ADDRESS } from "../../../api/queryKeys";
import {
  QueryUserMailingAddressResponse,
  UserMailingAddress,
} from "../../../types";

export default function useUpdateMailingAddress() {
  const queryClient = useQueryClient();
  return useMutation<
    QueryUserMailingAddressResponse,
    AxiosError,
    { address: UserMailingAddress["shipping_address"] }
  >(
    ({ address }) =>
      api
        .patch(QUERY_SHIPPING_ADDRESS, {
          mailing_address_street: address.street,
          mailing_address_unit: address.unit,
          mailing_address_city: address.city,
          mailing_address_state: address.state,
          mailing_address_zip_code: address.zip_code,
        })
        .then((res) => res.data),
    {
      onError: (error) => {
        toast.error("Unable to update mailing address");
      },
      onSuccess: () => {
        queryClient.refetchQueries([QUERY_SHIPPING_ADDRESS]);
      },
    }
  );
}
